var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 9.78L28.1399 18.15L28.8299 19.65L30.3299 19.875L39.5699 21.21L32.9999 27.66L31.8749 28.755L32.1449 30.255L33.7199 39.45L25.4549 35.115L23.9999 34.5L22.6049 35.235L14.3399 39.51L15.8399 30.315L16.1099 28.815L14.9999 27.66L8.36992 21.135L17.6099 19.8L19.1099 19.575L19.7999 18.075L23.9999 9.78ZM23.9999 3L17.1749 16.83L1.91992 19.035L12.9599 29.805L10.3499 45L23.9999 37.83L37.6499 45L35.0399 29.805L46.0799 19.05L30.8249 16.83L23.9999 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic-star.ebe1f601d0a198226858ba4e60ad9606.svg";
export { ForwardRef as ReactComponent };